export default function bombora() {
  return `
  <script>
    (function (w,d,t) {
      _ml = w._ml || {};
      _ml.eid = '50190';
      _ml.ef = ['#cds_email','.cds_email','.email','.inputEmail','.newsletters'];
      var s, cd, tag; s = d.getElementsByTagName(t)[0]; cd = new Date();
      tag = d.createElement(t); tag.async = 1;
      tag.src = 'https://ml314.com/tag.aspx?' + cd.getDate() + cd.getMonth();
      s.parentNode.insertBefore(tag, s);
    })(window,document,'script');
  </script>
  `;
}
